var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('h2',[_vm._v(_vm._s(_vm.$t("page.404.line_one")))]),_c('h2',[_vm._v(_vm._s(_vm.$t("page.404.line_two")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }